const AppIcons = {
  MapPin: require("./MapPin.svg"),
  propBg2: require("../propBg2.png"),
};
